export default "__VITE_ASSET__DYhpRh2S__"